import React from 'react';
import styles from '../assets/styles/ServiceLegalRepresentationRationale.module.css';
import { RiShieldCheckFill } from "react-icons/ri";

const ServiceLegalRepresentationRationale = ({ header, content }) => {
  return (
    <div>
      <div className={styles.serviceLegalRepresentationRationale}>
        <div className={styles.headerRow}>
          <div className={styles.icon}>{<RiShieldCheckFill />}</div>
          <div className={styles.header}>{header}</div>
        </div>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};

export default ServiceLegalRepresentationRationale;